import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import { gsap } from 'gsap'
import ButtonCta from '@components/atoms/button-cta'
import IconArrowRight from '@components/atoms/icons/icon-arrow-right'
import useStyles from './info-card-variant.styles'

const InfoAndImageCardWithOverlay = (props) => {
  const {
    precedingHeading,
    heading,
    cardImage,
    overlayList,
    overlayActionLabel,
    overlayActionHref,
    overlayActionOnClick,
    overlayToggleShowLabel = 'Show',
    overlayToggleHideLabel = 'Hide',
    overlayToggleSubject = 'Options',
    alwaysOverlayed = false,
    hideImageOverlay = false,
    overlayToggleHref,
    overlayToggleOnClick,
    overlayBackgroundColor,
    overlayOpacity,
  } = props
  const [isOverlayed, toggleOverlay] = useState(false)
  const list = React.createRef()
  const isOverlayVisible = alwaysOverlayed || isOverlayed

  const styles = useStyles({
    isOverlayed: isOverlayVisible,
    overlayBackgroundColor,
    overlayOpacity,
  })

  function showOptions() {
    const newVal = !isOverlayVisible
    toggleOverlay(newVal)

    if (newVal) {
      gsap.from(list.current, {
        y: 10,
        opacity: 0,
        duration: 0.25,
        delay: 0.175,
      })
    }
  }

  return (
    <div className={`${styles.infoCardWithOverlay} info-card-with-overlay`}>
      <div className={`${styles.copyContainer} info-card-with-overlay--copy-container`}>
        <h3 className={styles.copyHeading}>
          <span className={styles.copyOverline}>{precedingHeading}</span>
          {heading}
        </h3>
        {overlayToggleHref ? (
          <ButtonCta
            className={styles.showOptionsButton}
            variant="text"
            color="primary"
            href={overlayToggleHref}
            onClick={overlayToggleOnClick}
          >
            {`${overlayToggleShowLabel} ${overlayToggleSubject}`}
            <span className={styles.arrowRight}><IconArrowRight /></span>
          </ButtonCta>
        ) : (
          <Button
            className={styles.showOptionsButton}
            onClick={() => showOptions()}
            variant="text"
            color="primary"
            size="small"
            aria-expanded={!!isOverlayVisible}
          >{ isOverlayVisible ? `${overlayToggleHideLabel} ` : `${overlayToggleShowLabel} `}
            <span className={styles.a11yReader}>&nbsp;{heading}</span>
            &nbsp;{overlayToggleSubject} <span className={styles.arrowRight}><IconArrowRight /></span>
          </Button>
        )}
      </div>
      <div className={styles.imgContainer}>
        {!hideImageOverlay && (
          <div className={styles.imgOverlay}>
              <div className={styles.overlayContent} aria-hidden={!isOverlayVisible}>
                <ul className={styles.overlayList} ref={list}>
                  {overlayList && overlayList.map((listItem, i) => (
                    <li className={styles.overlayListItem} key={`career-tracks-overlay-list-item-${i + 1}`}>{listItem}</li>
                  ))}
                </ul>
                <div className={styles.andMoreCopy}>And More!</div>
                {(overlayActionLabel && overlayActionHref && !overlayToggleHref) && (
                  <ButtonCta
                    className={styles.overlayAction}
                    variant="text"
                    color="primary"
                    arrow
                    href={overlayActionHref}
                    onClick={overlayActionOnClick}
                  >
                    {overlayActionLabel}
                  </ButtonCta>
                )}
              </div>
          </div>
        )}
        <img className={styles.img} src={cardImage.url} alt="" />
      </div>
    </div>
  )
}

InfoAndImageCardWithOverlay.propTypes = {
  precedingHeading: PropTypes.string,
  heading: PropTypes.string,
  cardImage: PropTypes.object,
  overlayList: PropTypes.array,
  overlayActionLabel: PropTypes.string,
  overlayActionHref: PropTypes.string,
  overlayActionOnClick: PropTypes.func,
  overlayToggleShowLabel: PropTypes.string,
  overlayToggleHideLabel: PropTypes.string,
  overlayToggleSubject: PropTypes.string,
  alwaysOverlayed: PropTypes.bool,
  hideImageOverlay: PropTypes.bool,
  overlayToggleHref: PropTypes.string,
  overlayToggleOnClick: PropTypes.func,
  overlayBackgroundColor: PropTypes.string,
  overlayOpacity: PropTypes.number,
}

InfoAndImageCardWithOverlay.defaultProps = {}

export default InfoAndImageCardWithOverlay
